export function extractNumbers(inputString: string): string {
  const numbers = inputString.match(/\d+/g);
  const result = numbers ? numbers.join("") : "";
  return result;
}
